import { BehaviorSubject, Subject } from 'rxjs';

export class ReminderCountUpdatedService {
  private reminderCountRefresh: boolean = false;
  reminder: BehaviorSubject<boolean>;

  private reminderReadSubject = new Subject<void>();
  reminderRead$ = this.reminderReadSubject.asObservable();

  constructor() {
    this.reminder = new BehaviorSubject(this.reminderCountRefresh);
  }

  setNewReminderRefresh(newValue: boolean) {
    this.reminder.next(newValue);
  }

  notifyReminderRead() {
    this.reminderReadSubject.next();
  }
}